// extracted by mini-css-extract-plugin
export default {"container":"selectSupplier_container__BFgxC","remove":"selectSupplier_remove__KM4Ag","dropdown":"selectSupplier_dropdown__BtlJ7"};